export default __webpack_public_path__ + "static/media/07_tilt_up_down.fa394477.jpg";